import ScrollReveal from 'scrollreveal';

window.sr = ScrollReveal();

const reveal = (className) => {
  const itemsDOM = document.querySelectorAll(className);

  itemsDOM.forEach(item => {
    const delay = item.getAttribute('data-delay');
    const duration = item.getAttribute('data-duration');
    const dir = item.getAttribute('data-dir');

    let slideObj = {
      distance: '25%',
      opacity: 0,
      easing: 'ease-in-out',
      duration: 800 || duration,
      viewFactor: 0.15,
			delay,
			mobile: false
    };

    switch(dir){
      case 'up':
        slideObj.origin = 'bottom';
        break;
      case 'left':
        slideObj.origin = 'left';
        break;
      case 'right':
        slideObj.origin = 'right';
        break;
      default:
        slideObj.origin = 'bottom';
    }

    sr.reveal(item, slideObj);
  })
}

export default reveal